export default "__VITE_ASSET__BfMfG$RN__"